import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectWithCommissionFilter } from 'shared/selectors/advancedFilters';

export const WithCommissionContainer = () => {
  const { label, value } = useSelector(selectWithCommissionFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setCommissionType', arguments: [newValue ? 0 : null] });
    },
    [onChange],
  );

  return (
    <InlineFilter>
      <Checkbox label={label} checked={value} onChange={handleChange} />
    </InlineFilter>
  );
};
